import { render, staticRenderFns } from "./EditTransition.vue?vue&type=template&id=15127c42&scoped=true"
import script from "./EditTransition.vue?vue&type=script&lang=js"
export * from "./EditTransition.vue?vue&type=script&lang=js"
import style0 from "./EditTransition.vue?vue&type=style&index=0&id=15127c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15127c42",
  null
  
)

export default component.exports